require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-campaign-consulta.json") })
        }
      }, "path---es-mx-campaign-consulta");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-campaign-consulta!./.cache/json/es-mx-campaign-consulta.json
// module id = 882
// module chunks = 231608221292675